export const NON_ATLAS_CLUSTER_NAME = 'Non-Atlas';
export const BLANK_MONGO_SERVICE_ID = '000000000000000000000000';
